<dialog-header [dialogRef]="dialogRef" headerKey="APP_VERSION" />
<div mat-dialog-content>
  <div class="details">
    <attribute-item *ngFor="let item of details" [item]="item" />
  </div>
  <buttons-wrapper>
    <button mat-flat-button type="button" color="primary" mat-dialog-close>{{ 'OK' | translate }}</button>
  </buttons-wrapper>
</div>
